import { ActionTypesEnum, IActionVesselPart } from "../../partsReducer";
import {
  IBaseModalForPartsProps,
  createBaseModalForParts,
  createBasePartValidator,
  extractEffectiveRefId,
} from "./createBaseModalForParts";
import { IVesselPartSpacer, VesselPartTypeEnum } from "open-vessel-definition";

import { getTranslation } from "../../../../../../../../../app/i18/i18tn";
import { z } from "zod";

type ICustomTypeSpacerPartWithoutId = Omit<IVesselPartSpacer, "id"> & {
  type: VesselPartTypeEnum.SPACER;
  id?: string; // For the edit
};

export function createModalForSpacer({
  spacerData,
  currentLabels,
  calculatedSlots,
  maxLen,
  defaultLen,
  onSubmitAction,
  spaceAvailableCalcFn,
}: {
  spacerData: ICustomTypeSpacerPartWithoutId;
  onSubmitAction: (data: IActionVesselPart) => void;
} & IBaseModalForPartsProps) {
  function createValidator(
    maxLen: number | undefined,
  ): z.Schema<ICustomTypeSpacerPartWithoutId> {
    return createBasePartValidator(maxLen).and(
      z.object({
        type: z.literal(VesselPartTypeEnum.SPACER),
        heatSrcBelow: z.boolean(),
      }),
    );
  }

  const id = spacerData.id;

  const dialog = createBaseModalForParts<ICustomTypeSpacerPartWithoutId>({
    data: spacerData,
    type: VesselPartTypeEnum.SPACER,
    maxLen,
    defaultLen,
    calculatedSlots,
    partFields: [
      {
        name: "heatSrcBelow",
        type: "checkbox",
        label: "view:view3D.partsParams.heatSrcBelow",
        initialValue: spacerData.heatSrcBelow,
      },
    ],
    currentLabels: currentLabels,
    createValidator,
    spaceAvailableCalcFn,
    onSubmit: (data, cmd) => {
      if (data) {
        if (id) {
          const cmd: IActionVesselPart = {
            action: ActionTypesEnum.REPLACE_SPACER_PART,
            id,
            details: {
              id,
              ...data,
            },
          };
          onSubmitAction(cmd);
        } else {
          const cmd: IActionVesselPart = {
            action: ActionTypesEnum.ADD_SPACER_PART,
            slotRefId: extractEffectiveRefId(data.slotRefId, data.posRef),
            posRef: data.posRef,
            details: {
              ...data,
            },
          };
          onSubmitAction(cmd);
        }
      } else {
        if (cmd) onSubmitAction(cmd);
      }

      dialog.hide();
    },
  });

  dialog.label = getTranslation("view:view3D.actions.addSpacer");
  dialog.show();
}
